import { BaseState } from '@/store/base-state';
import { today_date } from '@/utils';
import { EventsCalendar } from '../types';

export default class EventsCalendarState extends BaseState {
  events: EventsCalendar.EventsCalendarItem[] = [];
  events_format: EventsCalendar.MapEvent[] = [];

  search_events: EventsCalendar.MapEvent[] = [];

  focus_date = today_date();
  current_month = Number(today_date().split('-')[1]);
  current_year = Number(today_date().split('-')[0]);

  filters: EventsCalendar.EventsCalendarFilters = {
    search: '',
    month: this.current_month,
    year: this.current_year,
  };
}
